import { tasksPageRequests } from "@/src/api/tasksPageRequests";
import { buildAdmissionPrefillPayloadFromTask } from "@/src/utils/tasks/buildAdmissionPrefillPayloadFromTask";
import { fetchApplicantUserInfo } from "@/src/utils/applicants/fetchApplicantUserInfo";
import {
  parseTaskApplicantId,
  parseTaskApplicantInfo,
  parseTaskNumericId,
} from "@/src/utils/tasks/parseTaskApplicantInfo";
import type { AdmissionTaskPrefillPayload } from "@/src/hooks/useAdmissionTaskPrefill";

export const fetchAdmissionPrefillPayloadByTaskId = async (
  taskId: string,
): Promise<AdmissionTaskPrefillPayload | null> => {
  const normalizedId = taskId.trim();
  if (!normalizedId) return null;

  const rawTask = await tasksPageRequests.getById(normalizedId);
  if (!rawTask) return null;

  const applicantInfo = parseTaskApplicantInfo(rawTask.applicant_info);
  const applicantId = parseTaskApplicantId(applicantInfo, rawTask.applicant_id);

  let applicantUserInfo: Parameters<typeof buildAdmissionPrefillPayloadFromTask>[0]["applicantUserInfo"];
  if (applicantId > 0) {
    try {
      const userInfo = await fetchApplicantUserInfo(applicantId);
      if (userInfo) {
        applicantUserInfo = {
          fullname: userInfo.fullname,
          fullnameNat: userInfo.fullnameNat,
          dateOfBirth: userInfo.dateOfBirth,
          nationality: userInfo.nationality,
          form_office: userInfo.form_office,
          levelEducation: userInfo.levelEducation,
        };
      }
    } catch (error) {
      console.warn("[AdmissionOffice] Failed to load applicant info for task prefill:", error);
    }
  }

  const rowId = parseTaskNumericId(rawTask.id);
  return buildAdmissionPrefillPayloadFromTask({
    rowId,
    rawTask,
    taskId: rawTask.id,
    applicantUserInfo,
  });
};
